import { render, staticRenderFns } from "./500.vue?vue&type=template&id=10338baf"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10338baf')) {
      api.createRecord('10338baf', component.options)
    } else {
      api.reload('10338baf', component.options)
    }
    module.hot.accept("./500.vue?vue&type=template&id=10338baf", function () {
      api.rerender('10338baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/error-page/500.vue"
export default component.exports